function SeoMenuController ( SeoMenuService ) {

    "ngInject";

    var vm = this;
    vm.seoMenuService = SeoMenuService;
    vm.seoMenuService.getSeoMenu();
}

module.exports = SeoMenuController;